import request from '@/service/requestServe'
const api = '/amount'
/**
 * 
 * @param {*} type sampleProject|business
 * @returns 
 */
export const getSubScibe = async (type = 'business') => {
    return request.get(api + `/amount/subscribeinfo`, {
        tokenType: type
    });
}